import { $ } from 'hanako-ts/dist/Framework';
import { Component } from 'hanako-ts/dist/Component';
import { Collection } from 'hanako-ts/dist/Collection';
import { PageAppear } from '../../components/PageAppear';

export class PageArchive extends Component {
  constructor() {
    super('PageArchive', false);
  }

  public async init(): Promise<void> {
    await super.init();

    $('[data-filter] a').on('click', (event: Event, filter: Collection) => {
      event.preventDefault();

      const filterElement = filter.parents('[data-filter]');

      filterElement.find('a').attr('data-selected', 'false');
      filter.attr('data-selected', 'true');

      this.applyFilters();
    });

    this.success();
  }

  private applyFilters() {
    $('.initial, [data-filter-section], [data-filter-item]').removeClass('hidden');

    $('[data-filter]').each((filter: Collection) => {
      var parameter: string = filter.data('filterType');
      var value: string = filter.find('[data-selected="true"').data('value');

      if (value == 'all') return;

      $('[data-filter-item]').each((item: Collection) => {
        const dataField = item.data(parameter) || '';
        var itemParameter: Array<string> = dataField.toString().split(',');

        if (itemParameter.indexOf(value) == -1) item.addClass('hidden');
      });
    });

    $('[data-filter-section]').each((section: Collection) => {
      if (section.find('[data-filter-item]:not(.hidden').length == 0) section.addClass('hidden');
    });

    PageAppear.scanContent();
    PageAppear.appear();
  }
}
